import './WNBALogo.css'

const WNBALogo = (props) => {

    return (
        <div onClick={props.onClick} className="appbar-wnba-logo appbar-wnba-logo-rightMargin"></div>
    )
}

export default WNBALogo;